import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import * as layoutActions from '../../core/store/layout/layout.actions';
import { Asset, Photo } from '../../core/store/models';
import { rootSelectors } from '../../core/store/selectors';
import { Severity } from '../../core/store/types';

@Component({
    selector: 'ah-photo-upload',
    templateUrl: './photo-upload.component.html',
    styleUrls: ['./photo-upload.component.scss'],
    standalone: false
})
export class PhotoUploadComponent implements OnInit, AfterViewInit {
    @Input() asset: Asset;
    @Input() assets: Asset[];
    @Input() basic = false;
    @Input() chooseLabel = 'Choose';
    @Output() afterUpload = new EventEmitter<Photo[]>();
    @Output() savingMessage = new EventEmitter<any[]>();
    @Input() isShowDragContent: boolean = true;

    files: File[] = [];
    accept: string;
    disableUpload = false;

    constructor(private store: Store<rootSelectors.State>) { }

    ngOnInit() {
        this.accept = 'image/*';
    }

    ngAfterViewInit(): void {
        const uploadButtons = Array.from(document.getElementsByClassName('p-ripple p-element p-button p-component p-disabled') as HTMLCollectionOf<HTMLElement>);
        uploadButtons.forEach(element => {
            element.setAttribute('style', 'background-color: #ff4409 !important; color: white !important;opacity: 1;')
        })
    }

    onBeforeUpload(event: { formData: FormData }) {
        this.savingMessage.emit([{ severity: Severity.Info, summary: 'Saving...' }]);
        if (this.asset) {
            event.formData.append('studio_id', this.asset.studio_id.toString());
            event.formData.append('asset_id', this.asset.id.toString());
            this.disableUpload = true;
        }
        else if (this.assets) {
            event.formData.append('studio_id', this.assets[0].studio_id.toString());
            event.formData.append('asset_id', this.assets[0].id.toString());
            event.formData.append('asset_ids', this.assets.map(asset => asset.id).join(','));
            this.disableUpload = true;
        }
    }

    onUpload(event: { originalEvent: HttpResponse<Photo[]>; files: File[] }) {
        const request = event.originalEvent;
        if (request && request.status === 200) {
            try {
                const photos = request.body;
                const newPhotos: Photo[] = photos.map(photo => new Photo(photo));
                this.afterUpload.emit(newPhotos);
            } catch (error) {
                this.store.dispatch(new layoutActions.ErrorAction({ error }));
            }
        }
        this.disableUpload = false;
    }

    onError(error: any) {

        this.disableUpload = false;
        const message = error?.error?.error?.message;
        this.store.dispatch(new layoutActions.ErrorAction({
            error: new HttpErrorResponse({ error: new Error(message?.includes('Read-Only Access') ? message : 'There was an error uploading one or more image files. We accept .jpg and .png files with a max combined file size of 20MB. If you believe this file was rejected in error, please reach out to support@synconset.com') })
        }));
    }

    onFileSelect($event) {
        const files: FileList = $event.files;
        for (const file of files as any) {
            this.files.push(file)
        }
        this.isShowDragContent = !(this.files.length > 0);

    }

    onRemove($event) {
        const file = $event.file;
        this.files = this.files.filter(f => f.name != file.name)
        this.isShowDragContent = this.files.length === 0;
    }
}
